import React from 'react';

const ContactForm = () => {
    return (
        <div className="contact-form-container panel" style={{ width: '100%', margin: '40px auto' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Get in Touch</h3>
            <p style={{ textAlign: 'center', color: 'var(--text-muted)', marginBottom: '20px', fontSize: '0.9rem' }}>
                Have feedback or feature requests?
            </p>

            <form
                name="contact"
                method="POST"
                data-netlify="true"
                style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}
            >
                <input type="hidden" name="form-name" value="contact" />

                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    required
                    style={{
                        padding: '10px',
                        backgroundColor: '#08090c',
                        border: '1px solid #334155',
                        color: '#fff',
                        borderRadius: '4px',
                        fontFamily: 'var(--font-tech)'
                    }}
                />

                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    required
                    style={{
                        padding: '10px',
                        backgroundColor: '#08090c',
                        border: '1px solid #334155',
                        color: '#fff',
                        borderRadius: '4px',
                        fontFamily: 'var(--font-tech)'
                    }}
                />

                <textarea
                    name="message"
                    placeholder="Your Message"
                    required
                    style={{
                        padding: '10px',
                        backgroundColor: '#08090c',
                        border: '1px solid #334155',
                        color: '#fff',
                        borderRadius: '4px',
                        fontFamily: 'var(--font-tech)',
                        minHeight: '100px',
                        resize: 'vertical'
                    }}
                ></textarea>

                <button
                    type="submit"
                    style={{
                        padding: '12px',
                        backgroundColor: 'var(--color-primary)',
                        color: '#000',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em'
                    }}
                >
                    Send Message
                </button>
            </form>
        </div>
    );
};

export default ContactForm;
